import Vue from 'vue'
import Vuex from 'vuex'
import * as fb from '../firebase'
import router from '../router/index'

Vue.use(Vuex)

// realtime firebase
// fb.articlesCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//   let articlesArray = []

//   snapshot.forEach(doc => {
//     let article = doc.data()
//     article.id = doc.id

//     articlesArray.push(article)
//   })

//   store.commit('setArticles', articlesArray)
// })

const store = new Vuex.Store({
  state: {
    userProfile: {},
    errorMsg: '',
    snackbar: false,
    showBottomNavButton: true,
    showBottomNavButton2: true
  },
  mutations: {
    setUserProfile (state, val) {
      state.userProfile = val
    },
    setErrorMsg (state, val) {
      state.errorMsg = val
    },
    setSnackbar (state, val) {
      state.snackbar = val
    },
    setShowBottomNavButton (state, value) {
      state.showBottomNavButton = value
    },
    setShowBottomNavButton2 (state, value) {
      state.showBottomNavButton2 = value
    }
  },
  actions: {
    toggleBottomNavButton ({ commit }, value) {
      commit('setShowBottomNavButton', value)
    },

    toggleBottomNavButton2 ({ commit }, value) {
      commit('setShowBottomNavButton2', value)
    },

    async login ({ dispatch, commit }, form) {
      try {
        commit('setErrorMsg', '')
        const { user } = await fb.auth.signInWithEmailAndPassword(form.email, form.password)
        dispatch('fetchUserProfile', user).then(() => {
          commit('setErrorMsg', 'Bienvenue !')
          commit('setSnackbar', true)
          router.push('/')
        })
      } catch (err) {
        console.log(err.code + ' / ' + err.message + ' snack : ' + this.snackbar)
        commit('setSnackbar', true)
        this.errorMsg = err.message
        this.errorMsg = (err.code === 'auth/wrong-password') ? 'Mot de passe incorrect' : this.errorMsg
        this.errorMsg = (err.code === 'auth/user-not-found') ? 'Email inconnu' : this.errorMsg
        this.errorMsg = (err.code === 'auth/invalid-email') ? 'Email invalide' : this.errorMsg
        this.errorMsg = (err.code === 'auth/user-disabled') ? 'Utilisateur interdit' : this.errorMsg

        commit('setErrorMsg', this.errorMsg)
        setTimeout(function () { commit('setSnackbar', false) }, 3000)
      }

      // fetch user profile and set in state
    },
    async signup ({ dispatch }, form) {
      // sign user up
      const { user } = await fb.auth.createUserWithEmailAndPassword(form.email, form.password)

      // create user object in userCollections
      await fb.usersCollection.doc(user.uid).set({
        name: form.name,
        title: form.title
      })

      // fetch user profile and set in state
      dispatch('fetchUserProfile', user)
    },
    async fetchUserProfile ({ commit }, user) {
      // fetch user profile
      const userProfile = await fb.usersCollection.doc(user.uid).get()

      // set user profile in state
      commit('setUserProfile', userProfile.data())
    },
    async logout ({ commit }) {
      // log user out
      await fb.auth.signOut()

      // clear user data from state
      commit('setUserProfile', {})

      // redirect to login view
      router.push('/login')
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js